import { ChartWindowState, Size } from '@ardoq/graph';
import { actionCreator } from '@ardoq/rxbeach';

export const setClientRectState = actionCreator<Size>(
  '[Visualization State] SET_CLIENT_RECT'
);
export const setChartWindowState = actionCreator<ChartWindowState>(
  '[Visualization State] SET_CHART_WINDOW_STATE'
);
